import style from "./AuthPrompt.module.css";
import Icon from "@/ui/icon/Icon";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useLoginWithGoogle } from "../../hooks/useLoginWithGoogle";
import { useFreeCourses } from "@/features/courses/hooks/useFreeCourses";

function AuthPrompt({ popup }) {
	const { t } = useTranslation();
	const { loginWithGoogle } = useLoginWithGoogle();
	const { freeOffer } = useFreeCourses();

	return (
		<div className={`${style.container} ${popup ? style.popup : ""}`}>
			<div className={style.header}>
				<h2>{t("auth:prompt.title")}</h2>
				<p>
					<Trans
						i18nKey="auth:prompt.unlock"
						values={{ offer: freeOffer }}
						components={{ offer: <span /> }}
					/>
				</p>
			</div>

			<div className={style.methods}>
				<div onClick={loginWithGoogle} className={style.method}>
					<div className={style.icoHolder}>
						<Icon icon="fa-google" iconType="fa-brands" />
					</div>
					<span>{t("auth:prompt.withGoogle")}</span>
				</div>
				<Link to="/register" className={style.method}>
					<div className={style.icoHolder}>
						<Icon icon="fa-envelope" iconType="fa-solid" />
					</div>
					<span>{t("auth:prompt.withEmail")}</span>
				</Link>
			</div>
			<div className={style.divider}>
				<div className={style.line}></div>
				<span>{t("common:divider.or")}</span>
				<div className={style.line}></div>
			</div>
			<div className={style.login}>
				<p>{t("auth:prompt.haveAccount")}</p>
				<Link className={style.method} to="/login">
					<div className={style.icoHolder}>
						<Icon icon="fa-user" />
					</div>
					<span>{t("common:nav.login")}</span>
				</Link>
			</div>
		</div>
	);
}

export default AuthPrompt;
